module.exports = __webpack_public_path__ + "static/media/twitter.1c32ff4c.png";